
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'MainheaderComponent',
    props: {
        title: {
            type: String,
            required: true
        }
    }
})
